/**
 * 頁面服務
 * 處理頁面的創建、查詢、更新、發布和版本控制等操作
 */

import { Page } from "../models/page";
import { api, endpoints } from "@/infrastructure/api";

export const pageService = {
  /**
   * 獲取專案的所有頁面
   * @param projectId 專案 ID
   * @returns 頁面列表
   */
  async getProjectPages(projectId: string): Promise<Page[]> {
    return await api.get<Page[]>(endpoints.pages.list(projectId));
  },

  /**
   * 根據 ID 獲取頁面詳情
   * @param id 頁面 ID
   * @returns 頁面詳情
   */
  async getPageById(projectId: string, id: string): Promise<Page> {
    return await api.get<Page>(endpoints.pages.detail(projectId, id));
  },

  /**
   * 獲取頁面資料並轉換為 UI 層使用的格式
   * @param id 頁面 ID
   * @returns UI 層使用的頁面資料
   */
  // async getPageDataById(id: number): Promise<PageData> {
  //   const page = await this.getProjectPagesSafe(id);
  //   return toPageData(page.pages[0]);
  // },

  /**
   * 創建新頁面
   * @param page 頁面創建請求數據
   * @returns 新創建的頁面
   */
  // async createPage(page: CreatePageRequest): Promise<Page> {
  //   return await api.post<Page>(endpoints.pages.list, page);
  // },

  /**
   * 刪除頁面
   * @param id 頁面 ID
   */
  // async deletePage(id: number): Promise<void> {
  //   await api.delete<void>(endpoints.pages.detail(id));
  // },

  /**
   * 發布頁面
   * @param request 發布請求數據
   * @returns 發布後的頁面
   */
  // async publishPage(request: PublishPageRequest): Promise<Page> {
  //   return await api.post<Page>(
  //     endpoints.pages.publish(request.pageId),
  //     request,
  //   );
  // },

  /**
   * 獲取頁面版本列表
   * @param pageId 頁面 ID
   * @returns 頁面版本列表
   */
  // async getPageVersions(pageId: number): Promise<PageVersion[]> {
  //   return await api.get<PageVersion[]>(endpoints.pages.versions.list(pageId));
  // },

  /**
   * 獲取特定版本的頁面
   * @param pageId 頁面 ID
   * @param versionId 版本 ID
   * @returns 頁面版本
   */
  // async getPageVersion(
  //   pageId: number,
  //   versionId: number,
  // ): Promise<PageVersion> {
  //   return await api.get<PageVersion>(
  //     endpoints.pages.versions.detail(pageId, versionId),
  //   );
  // },

  /**
   * 應用特定版本到當前頁面
   * @param pageId 頁面 ID
   * @param versionId 版本 ID
   * @returns 更新後的頁面
   */
  // async applyPageVersion(pageId: number, versionId: number): Promise<Page> {
  //   return await api.post<Page>(
  //     endpoints.pages.versions.apply(pageId, versionId),
  //     {},
  //   );
  // },
};
